module.exports = __webpack_public_path__ + "static/img/bg_01.c54eced.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/themes/bg_01.jpg
// module id = PJy9
// module chunks = 29